// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { Separator } from '@tectonics/look-and-feel/shopify/commons/atoms';

export function PaynetPaymentLocation(): Node {
  return (
    <PaymentLocationTextWrapper>
      Usted podrá pagar este cupón en cualquer sucursal afiliada de PayNet:
      <Separator direction="vertical" size={3} />
      <BoldText>
        Farmacias Benavides, 7-Eleven, Walmart, Farmacias del Ahorro, Sams Club, 
        Superama, Bodega Aurrera, Circle K, Extra, El Asturiano, Waldos, 
        Alsuper, Kiosko o Farmacias Guadalajara.
      </BoldText>
    </PaymentLocationTextWrapper>
  );
}

const PaymentLocationTextWrapper = styled.div`
  grid-column: 1/3;
  color: #808b9d;
`;

const BoldText = styled.b`
  font-weight: bold;
`;
